import { useParams } from "react-router-dom";
import Container from "../../components/container/Container";
import useRoomId from "../../hooks/DatabseCollection/useRoomId";
import RoomDetailHeader from "../../components/RoomDetailHeader/RoomDetailHeader";
import { ClipLoader } from "react-spinners";
import RoomTabs from "../../components/RoomTabs/RoomTabs";

const RoomDetail = () => {
  const { roomId } = useParams();
  const { roomDetail, loading } = useRoomId(roomId);

  return (
    <div className="lg:px-0 w-full">
      {loading ? (
        <div className="flex justify-center mt-10">
          <ClipLoader color="black" loading={loading} size={70} />
        </div>
      ) : (
        <>
          <Container>
            <div className="py-6 px-3 lg:px-0">
              <RoomDetailHeader roomDtails={roomDetail} />
            </div>
          </Container>

          <div className="bg-white w-full h-[540px] border-t border-gray-300">
            <Container>
              <RoomTabs />
            </Container>
          </div>
        </>
      )}
    </div>
  );
};

export default RoomDetail;
